<section class="content-header">

    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-6">
                <h1 class="m-0 text-dark">Testing</h1>
            </div>

        </div>
        <!-- /.row -->
    </div>
    <!-- /.container-fluid -->
</section>
<!-- /.content-header -->
<section class="content">
    <!-- Default box -->
    <div class="container-fluid">

        <div class="card">
            <div class="card-header">
                <h3 class="card-title">Add New Testing</h3>

            </div>
            <div class="card-body">

                Select Product
                <br>
                <br>
                <ng-select [items]="products" bindLabel="productName" autofocus bindValue="productId"
                    [(ngModel)]="selectedproductId" (change)="productChanged()">
                </ng-select>
                <br>
                <input type="button" value="Reset" (click)="resetPage()" class="button resetbutton">
                <div *ngIf="selectedproductId!=undefined">

                    <br>
                    <b>Selected Product: {{selectedProductName}} </b>
                    <hr>

                    <div>
                        <label>Product Name <b style="color:red;">*</b></label>
                        <input type="text" [(ngModel)]="testingProductName" value="testingProductName" required
                            class="form-control" />

                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Name of Consumer <b style="color:red;">*</b></label>
                                    <input type="text" [(ngModel)]="consumerName" value="consumerName" required
                                        class="form-control" />

                                     <label>Sample Description <b style="color:red;">*</b></label>
                                        <input type="text" [(ngModel)]="sampleDescription" value="sampleDescription"
                                            required class="form-control" />

                                    <label>Physical Examination/Sensory Evaluation Test <b style="color:red;">*</b></label>
                                        <input type="text" [(ngModel)]="physicalExamination" value="physicalExamination"
                                                required class="form-control" />
                                    
                                     <label>Chemical Analysis <b style="color:red;">*</b></label>
                                            <input type="text" [(ngModel)]="chemicalAnalysis" value="chemicalAnalysis" required
                                                class="form-control">
    
                                    <label>Any Other Observations <b style="color:red;">*</b></label>
                                        <textarea [(ngModel)]="otherObservations" value="otherObservations" required
                                            class="form-control"></textarea>

                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">

                                    <label>Name of FBO <b style="color:red;">*</b></label>
                                    <input type="text" [(ngModel)]="fboName" value="fboName" required
                                    class="form-control" /> 
                                    
                                    <label>District/Area <b style="color:red;">*</b></label>
                                    <input type="text" [(ngModel)]="district" value="district" required
                                        class="form-control" />

                                    <label>Label Declaration <b style="color:red;">*</b></label>
                                    <input type="text" [(ngModel)]="labelDeclaraton" value="labelDeclaraton" required
                                        class="form-control" />

                                    <label>Adulterated/Misbranded/Within norms/Violates provision of <b style="color:red;">*</b></label>
                                    <input type="text" [(ngModel)]="adulterated" value="adulterated" required
                                    class="form-control" />
    
                                </div>
                            </div>
                        </div>
                    </div>

                    <hr>

                    <b>Parameters: <i class="fa fa-question-circle" data-toggle="tooltip" data-html="true"
                        title="If you wish to add extra test parameters for testing, kindly add the parameter below and click 'Add' button"
                        data-placement="top" aria-hidden="true"></i></b>

                    <table class="table table-striped table-hover table-bordered">
                        <thead>
                            <tr>
                                <td style="font-weight:bold">Tested/Not Tested</td>
                                <td style="font-weight:bold">Parameter</td>
                                <td style="font-weight:bold">Value</td>                                
                                <td style="font-weight:bold">Recommended Value</td>
                                <td style="font-weight:bold">Result</td>
                            </tr>
                        </thead>

                        <tbody>
                            <tr *ngFor="let parameter of parameters;let i=index">
                                <td>
                                    <input #chkEnable type="checkbox" (change)="check($event,i)"
                                        [(ngModel)]="parameter.selectedParameter" id="{{parameter.id}}" name="selectedParameter"
                                        checked />
                                </td>

                                <td>{{ parameter.parameterName }}</td>
                                <td>
                                    <input type="text" [(ngModel)]="parameter.value"
                                        [ngClass]="{ 'is-invalid': submitted && parameter.value.errors }" required
                                        [disabled]="!chkEnable.checked">
                                    <div *ngIf="submitted && parameter.value.errors" class="invalid-feedback">
                                        <div *ngIf="parameter.value.errors.required">
                                            Parameter value is required
                                        </div>
                                    </div>
                                </td>

                                <td>
                                    <input type="text" [(ngModel)]="parameter.recommendedValue"
                                        [ngClass]="{ 'is-invalid': submitted && parameter.recommendedValue.errors }" required
                                        [disabled]="!chkEnable.checked">
                                    <div *ngIf="submitted && parameter.recommendedValue.errors" class="invalid-feedback">
                                        <div *ngIf="parameter.value.errors.required">
                                            Recomended Parameter value is required
                                        </div>
                                    </div>
                                </td>

                                <td>
                                    Pass: <input type="radio" value="Pass" [(ngModel)]="parameter.result"
                                        id="{{parameter.id}}" name="{{parameter.id}}" checked (change)="handleChange($event)"
                                        [disabled]="!chkEnable.checked" />
                                    Fail:<input type="radio" value="Fail" [(ngModel)]="parameter.result"
                                        id="{{parameter.id}}" name="{{parameter.parameterName}}" (change)="handleChange($event)"
                                        [disabled]="!chkEnable.checked" />
                                </td>

                            </tr>
                            

                        </tbody>
                    </table>

                    <div>
                        <b><p style="color:green;">Sample Result: {{sampleResult}}</p></b>
                    </div>

                    <hr>

                    <div>
                        <b>Add Parameters: <i class="fa fa-question-circle" data-toggle="tooltip" data-html="true"
                                title="If you wish to add extra test parameters for testing, kindly add the parameter below and click 'Add' button"
                                data-placement="top" aria-hidden="true"></i></b>
                        <table class="table table-striped table-hover table-bordered">
                            <thead>
                                <tr>
                                    <td style="font-weight:bold">Parameter</td>
                                    <td style="font-weight:bold">Value</td>
                                    <td style="font-weight:bold">Recommended Value</td>
                                    <td style="font-weight:bold">Result</td>
                                    <td style="font-weight:bold">Actions</td>

                                </tr>
                            </thead>

                            <tbody>
                                <tr *ngFor="let parameter of addParameters">
                                    <td>{{parameter.parameterName}}</td>
                                    <td>{{parameter.value}}</td>
                                    <td>{{parameter.recommendedValue}}</td>
                                    <td>{{parameter.result}}</td>
                                    <td></td>
                                </tr>
                                <tr>                
                                    <td><input type="text" [(ngModel)]="parameterName"></td>
                                    <td><input type="text" [(ngModel)]="value"></td>
                                    <td><input type="text" [(ngModel)]="recommendedValue"></td>

                                    <td>
                                        Pass: <input type="radio" value="Pass" [(ngModel)]="result" id="pass" (change)="addMoreParam($event)"
                                            name="pass" checked />
                                        Fail:<input type="radio" value="Fail" [(ngModel)]="result" id="fail" (change)="addMoreParam($event)"
                                            name="fail" />
                                    </td>
                                    <td><input type="button" value="Add" (click)="addMoreParameter()"></td>
                                </tr>
                            </tbody>

                        </table>
                    </div>

                    <div>
                        <b><p style="color:green;">Additional Sample Result: {{sampleResultOther}}</p></b>
                    </div>

                    <!-- <b>Upload Report:</b>
                    <div class="form-group">
                        <div class="row">
                            <div class="col-3">
                                <label class="btn btn-default p-0">
                                    <input type="file" #myInput multiple (change)="onFileSelect($event)" />
                                </label>
                            </div>
                            <div class="col-1">
                                <input type="button" value="Upload" class="btn btn-success btn-sm" (click)="submit()"
                                    [disabled]="!fileName">
                            </div>
                            <div class="col-4">
                                <div style="font-weight:bold;margin-top: -10px;">Max file size:3 Mb<br />
                                    Type(jpeg,jpg,png,pdf)</div>
                            </div>
                        </div>
                        <div class="card mt-3" *ngIf="success==true">
                            <div class="card-header">List of Files</div>
                           
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <td style="font-weight:bold">Sr. No.</td>
                                        <td style="font-weight:bold">File Name</td>
                                        <td style="font-weight:bold">Actions</td>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr
                                        *ngFor="let file of fileInfos | paginate : {itemsPerPage: 10, currentPage : p}; let i=index">
                                        <td>{{ itemsPerPage * (p - 1) + i + 1 }}</td>
                                        <td>{{ file.filename }}</td>
                                        <td>
                                            <input type="button" (click)="deleteRow(file)" value="Delete"
                                                class="btn btn-danger">
                                        </td>
                                     
                                    </tr>
                                </tbody>
                            </table>
                           
                        </div>
                    </div>
                 -->
                    <br />

                    <div class="form-group"><input type="submit" (click)="updateInsertData()" value="Submit"
                            class="btn btn-primary"></div>
                    <div *ngIf="submitted">
                        <!-- <h3>Record saved successfully!</h3> -->
                    </div>
                </div>


            </div>
        </div>
    </div>
</section>
<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
    <p style="color: white">Please Wait. </p>
</ngx-spinner>